var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { PagerItemDisabled, PagerLinkDisabled, PagerItem, PagerLink } from '../../Table.styled';
import { getAutomation, useMobile } from '@citrus/runtime';
import { isNilOrEmpty } from '@pcty/utils';
import { getVisiblePages, goForwardAPageRange } from './utils';
var ForwardEllipsis = function (_a) {
    var automationId = _a.automationId, disabled = _a.disabled, itemCount = _a.itemCount, goToPage = _a.goToPage, numberOfVisiblePages = _a.numberOfVisiblePages, page = _a.page, pageCount = _a.pageCount;
    var mobile = useMobile(700);
    var _b = useState(getVisiblePages(mobile, numberOfVisiblePages, page, pageCount)), visiblePages = _b[0], setVisiblePages = _b[1];
    useEffect(function () {
        setVisiblePages(getVisiblePages(mobile, numberOfVisiblePages, page, pageCount));
    }, [mobile, numberOfVisiblePages, page, pageCount]);
    if (isNilOrEmpty(itemCount) || itemCount <= 0)
        return null;
    if (disabled) {
        return visiblePages.indexOf(pageCount) === -1 ? (React.createElement(PagerItemDisabled, null,
            React.createElement(PagerLinkDisabled, __assign({}, getAutomation(automationId, 'nextrange')), "..."))) : null;
    }
    return visiblePages.indexOf(pageCount) === -1 ? (React.createElement(PagerItem, null,
        React.createElement(PagerLink, __assign({ onClick: function (e) { return goToPage(goForwardAPageRange(mobile, numberOfVisiblePages, page, pageCount, e)); } }, getAutomation(automationId, 'nextrange')), "..."))) : null;
};
export default ForwardEllipsis;
